const INIT = {
  orders: null,
  orderDetails: null,
  error: null,
};

export default (state = INIT, {
  type, orders, orderDetails, error,
}) => {
  switch (type) {
    case 'SET_ORDERS':
      return {
        ...state,
        orders,
      };

    case 'SET_ORDER_DETAILS':
      return {
        ...state,
        orderDetails,
      };

    case 'SET_ORDERS_ERROR':
      return {
        ...state,
        error,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/ordersReducer.js